import VuexPersistence from 'vuex-persist'
import { createStore } from 'vuex'

export function createMainStore (userId) {
  const vuexPersistTheme = new VuexPersistence({
    key: 'appTheme',
    storage: window.localStorage,
    modules: ['theme']
  })

  // Use the userId for persisting user-specific data like the shopping cart
  const vuexPersistUser = new VuexPersistence({
    key: `user-${userId}`,
    storage: window.localStorage,
    modules: ['shoppingCart']
  })

  const store = createStore({
    modules: {
      shoppingCart: {
        namespaced: true,
        state: () => ({
          items: []
        }),
        mutations: {
          pushProductToCart (state, { priceId, price, name }) {
            state.items.push({
              priceId,
              quantity: 1,
              price,
              name
            })
          },
          incrementItemQuantity (state, { priceId }) {
            const cartItem = state.items.find(item => item.priceId === priceId)
            cartItem.quantity++
          },
          decrementItemQuantity (state, { priceId }) {
            const cartItem = state.items.find(item => item.priceId === priceId)
            cartItem.quantity--
          },
          setCartItems (state, { items }) {
            state.items = items
          },
          removeProduct (state, priceId) {
            const index = state.items.findIndex(item => item.priceId === priceId)
            if (index !== -1) {
              state.items.splice(index, 1)
            }
          }
        },
        getters: {
          cartProducts: (state, getters, rootState) => {
            return state.items.map(({ priceId, quantity }) => {
              const product = rootState.shoppingCart.items.find(product => product.priceId === priceId)
              return {
                priceId: product.priceId,
                name: product.name,
                price: product.price,
                quantity
              }
            })
          },
          cartTotalPrice: (state, getters) => {
            return getters.cartProducts.reduce((total, product) => {
              return total + product.price * product.quantity
            }, 0)
          },
          cartTotalQuantity: (state, getters) => {
            return getters.cartProducts.reduce((total, product) => {
              return total + product.quantity
            }, 0)
          }
        },
        actions: {
          addProductToCart ({ state, commit }, product) {
            const cartItem = state.items.find(item => item.priceId === product.priceId)
            if (!cartItem) {
              commit('pushProductToCart', { priceId: product.priceId, price: product.price, name: product.name })
            } else {
              commit('incrementItemQuantity', cartItem)
            }
          },
          decrementProductQuantity ({ state, commit }, product) {
            const cartItem = state.items.find(item => item.priceId === product.priceId)
            if (cartItem && cartItem.quantity > 1) {
              commit('decrementItemQuantity', cartItem)
            }
          },
          incrementProductQuantity ({ state, commit }, product) {
            const cartItem = state.items.find(item => item.priceId === product.priceId)
            if (cartItem) {
              commit('incrementItemQuantity', cartItem)
            }
          },
          removeProductFromCart ({ state, commit }, priceId) {
            commit('removeProduct', priceId)
          },
          emptyCart ({ state, commit }) {
            commit('setCartItems', { items: [] })
          }
        }
      },
      theme: {
        namespaced: true,
        state: () => ({
          currentTheme: 'light'
        }),
        mutations: {
          setTheme (state, theme) {
            state.currentTheme = theme
          }
        },
        actions: {
          changeTheme ({ commit }, theme) {
            commit('setTheme', theme)
          }
        }
      }
    },
    plugins: [vuexPersistUser.plugin, vuexPersistTheme.plugin]
  })

  return store
}
